import { render } from "./ToolTra.vue?vue&type=template&id=2346d3d2&scoped=true"
import script from "./ToolTra.vue?vue&type=script&lang=js"
export * from "./ToolTra.vue?vue&type=script&lang=js"

import "./ToolTra.vue?vue&type=style&index=0&id=2346d3d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2346d3d2"]])

export default __exports__